import React from "react";
import {
  ReferenceField,
  TextField,
  SimpleShowLayout,
  SelectField,
  FunctionField,
  ArrayField,
  Datagrid,
} from "react-admin";
import { GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import { ccaTbfCodeList } from "./components/CcaTbfCodeInput";
import { ccaRateChartType, ccaRateChartTypeOptions } from "./const";
import CustomPriceField from "components/CustomPriceField";
import ShowWrapper from "../../components/ShowWrapper";
import CustomLabeled from "../../components/layout/CustomLabeled";

const RateChartShow = (props: any) => {
  const param = GetParam();

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    { title: "Pricing", link: `/schools/${param.get("schoolId")}/show/5` },
    { title: props.id, link: "" },
  ];

  return (
    <>
      <ShowWrapper
        breadcrumb={breadcrumb}
        customName={{
          resourceName: "CCA Rate Chart",
          propertyName: "name",
        }}
        actions={null}
        {...props}
      >
        <SimpleShowLayout>
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                School & CCA Academic Year
              </Typography>
            </Grid>

            <Grid item xs={3}>
              <CustomLabeled name="School">
                <ReferenceField source="schoolId" reference="schools">
                  <TextField source="name" />
                </ReferenceField>
              </CustomLabeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Academic Year">
                <ReferenceField
                  source="ccaAcademicYearId"
                  reference="ccaAcademicYears"
                >
                  <TextField source="name" />
                </ReferenceField>
              </CustomLabeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Tbf Code">
                <SelectField
                  source="tbfCode"
                  choices={ccaTbfCodeList}
                  emptyText="-"
                />
              </CustomLabeled>
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>
                Pricing Details
              </Typography>
            </Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Pricing Name">
                <TextField source="name" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Pricing Start Date">
                <CustomDateField source="startedAt" />
              </CustomLabeled>
            </Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Pricing End Date">
                <CustomDateField source="endedAt" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={6}></Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Invoice Issue Date">
                <CustomDateField source="invoiceIssuedAt" />
              </CustomLabeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={3}>
              <CustomLabeled name="Cca Rate Chart Type">
                <SelectField
                  source="ccaRateChartType"
                  choices={ccaRateChartTypeOptions}
                  emptyText="-"
                />
              </CustomLabeled>
            </Grid>
            <Grid item xs={9}></Grid>

            <Grid item xs={12}>
              <FunctionField
                render={(record: any) => (
                  <>
                    {record.ccaRateChartType ===
                      ccaRateChartType.costPerTripAndStudentType && (
                      <SanitizedGrid container spacing={2}>
                        <Grid item xs={3}>
                          <CustomLabeled name="Rider Price">
                            <CustomPriceField
                              source="riderPrice"
                              record={record.ccaRateChartCostPerTrip}
                            />
                          </CustomLabeled>
                        </Grid>
                        <Grid item xs={3}>
                          <CustomLabeled name="Non-Rider Price">
                            <CustomPriceField
                              source="nonRiderPrice"
                              record={record.ccaRateChartCostPerTrip}
                            />
                          </CustomLabeled>
                        </Grid>
                      </SanitizedGrid>
                    )}
                    {record.ccaRateChartType ===
                      ccaRateChartType.costPerTripBasedOnArea && (
                      <SanitizedGrid container spacing={2}>
                        <Grid item xs={12}>
                          <Typography variant="h6">
                            Area Pricing (Exclusive of GST)
                          </Typography>
                        </Grid>

                        {record.ccaRateChartAreaItems?.length > 0 ? (
                          <Grid item xs={4}>
                            <ArrayField source="ccaRateChartAreaItems">
                              <Datagrid>
                                <ReferenceField
                                  source="ccaAreaId"
                                  label="Area"
                                  reference="ccaAreas"
                                  link={false}
                                >
                                  <TextField source="name" />
                                </ReferenceField>
                                <CustomPriceField source="price" />
                              </Datagrid>
                            </ArrayField>
                          </Grid>
                        ) : (
                          <Grid item xs={12}>
                            <Typography variant="body1">
                              CCA Rate Charts Area Items is Empty.
                            </Typography>
                          </Grid>
                        )}
                      </SanitizedGrid>
                    )}
                    {record.ccaRateChartType ===
                      ccaRateChartType.costPerWeek && (
                      <SanitizedGrid container spacing={2}>
                        <Grid item xs={3}>
                          <CustomLabeled name="Price">
                            <CustomPriceField
                              source="price"
                              record={record.ccaRateChartCostPerWeek}
                            />
                          </CustomLabeled>
                        </Grid>
                      </SanitizedGrid>
                    )}
                  </>
                )}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleShowLayout>
      </ShowWrapper>
    </>
  );
};

export default RateChartShow;
